export default __webpack_public_path__ + "static/media/Fall_12.446309da.png";